import { CtaCard } from '@web/shared/ui';
import { RankingsCategory, RankingsType } from '../models/rankings.models';

export const CURRENT_RANKINGS_YEAR = '2026';

export const RANKINGS_METADATA = {
	title: `UK University Rankings & League Tables ${CURRENT_RANKINGS_YEAR}`,
	description:
		'Find the latest information on UK University rankings with our range of league tables based on your requirements. We have more than 13,000 student reviews to help you decide!',
};

export const SUBJECTS_PAGE_METADATA = {
	title: `University League Tables ${CURRENT_RANKINGS_YEAR} | Ranked by Subject`,
	description:
		"Discover university rankings for individual subjects based on real students' experiences. Find out more at Uni Compare.",
};

export const SUBJECTS_PAGE_HEADER_DATA = {
	title: `Rankings by subject ${CURRENT_RANKINGS_YEAR}`,
	description:
		"Using 131,000+ data points, we've ranked the top universities based on what students care about most - employability, social life and more. Discover ranks by subject right here.",
	backgroundStyle: 'bg-advice',
};

export const REGIONS_SLUGS = ['england', 'wales', 'northern-ireland', 'scotland', 'all'];

export const CATEGORY_SLUGS = [
	'accommodation',
	'course-quality',
	'career-opportunities',
	'student-life',
];

export const UNUSED_SLUGS: Readonly<string[]> = [
	'city',
	'sport',
	'rural',
	'creative',
	'dance',
	'coastal',
	'russell-group-universities',
	'russell-group',
	'cathedrals-group',
	'guild-he',
	'million-plus',
	'university-alliance',
];

export const RANKING_DATA: RankingsType[] = [
	{
		title: 'Search rankings by top categories',
		desc: 'Want to find the best university for societies? Looking to find a uni that prioritises employability! Check out our rankings split but categories that matter to you.',
		categories: <RankingsCategory[]>[
			{
				title: 'Accommodation',
				img: '/assets/img/Accomodation_Ranking_Image_Botton_Web_01.png',
				desc: 'Which universities offer top class accomodation options?',
				url: '/rankings/accommodation',
			},
			{
				title: 'Course quality',
				img: '/assets/img/Course_Quality_Rankings_Image_Botton_Web_01.png',
				desc: 'See the universities who are known for their quality teaching!',
				url: '/rankings/course-quality',
			},
			{
				title: 'Employability',
				img: '/assets/img/Graduate_Career_Rankings_Image_Botton_Web_02.png',
				desc: 'Discover universities with the best track record for their students landing jobs.',
				url: '/rankings/career-opportunities',
			},
			{
				title: 'Student life',
				img: '/assets/img/Student_Life_Rankings_Image_Botton_Web_01.png',
				desc: 'Which universities are recommended for best student social life?',
				url: '/rankings/student-life',
			},
		],
	},

	{
		title: 'Explore regional university rankings',
		desc: 'We break down our university rankings into regional areas so you can compare the best universities in England, Wales, Northern Ireland and Scotland.',
		categories: <RankingsCategory[]>[
			{
				title: 'England',
				img: '/assets/img/England_Rankings_Image_Botton_Web_01.png',
				desc: 'See which universities in England rank highest.',
				url: '/rankings/england',
			},
			{
				title: 'Wales',
				img: '/assets/img/Wales_Rankings_Image_Botton_Web.png',
				desc: 'See which Welsh universities are best for students.',
				url: '/rankings/wales',
			},
			{
				title: 'Northern Ireland',
				img: '/assets/img/Northern_Ireland_Rankings_Image_Botton_Web.png',
				desc: 'See which universities rank top in Northern Ireland.',
				url: '/rankings/northern-ireland',
			},
			{
				title: 'Scotland',
				img: '/assets/img/Scotland_Rankings_Image_Botton_Web.png',
				desc: 'See which universities rank highest in Scotland.',
				url: '/rankings/scotland',
			},
		],
	},
];

export const SUBJECT_RANKINGS_ENGAGE_DATA: CtaCard[] = [
	{
		title: 'Find [subject] personal statement examples',
		desc: 'Craft the perfect personal statement with examples submitted by students.',
		image: '/assets/img/Personal_Statement_Image_CTA_Web_02.png',
		link: '/personal-statement-examples/[subject]',
		external: false,
	},
	{
		title: 'Read our guide to [subject]',
		desc: 'Find out all there is to know about [subject] to help make the right decision for you.',
		image: '/assets/img/Subject_Guide_Image_CTA.png',
		link: '/guides/subject/[subject]',
		external: false,
	},
];

export const SUBJECT_RANKINGS_TOOLTIPS = {
	satisfaction: {
		title: 'Student Satisfaction',
		desc: 'Measures a student’s satisfaction with their time at university.',
	},
	reflections: {
		title: 'Future Career Reflections',
		desc: 'A measure of how confident graduates feel their course aligns with their future.',
	},
	outcomes: {
		title: 'Graduate Career Outcomes',
		desc: '% of graduates who find work after their course.',
	},
	researchQuality: {
		title: 'Research Quality',
		desc: 'Measures the quality of research taken at this university.',
	},
};
